import React from 'react';
import { useSelector } from 'react-redux';
import { filterBalances } from '../../../../client/Juno/helpers';
import AmountWithCurrency from '../../common/AmountWithCurrency';

const SellCurrencyForm = ({
    formData,
    amountError,
    handleAmountChange,
    handleAmountAndSetFormData,
    setFormData,
    selectedCryptoCurrency,
    setSelectedCryptoCurrency,
    selectedFiatCurrency,
    setSelectedFiatCurrency,
    exchangeLoading,
    exchangeRate,
    quotationError,
}) => {
    const { balancesCurrencies, unfreezeCryptoCurrencies } = useSelector(state => state.juno);
    const updatedUnfreezeCryptoCurrencies = filterBalances(unfreezeCryptoCurrencies);

    const allowedFiatCurrencies = ['USD', 'EUR', 'GBP'];

    const filteredFiatData = balancesCurrencies.filter(option => {
        if (option.currencyType === 'fiat') {
            return allowedFiatCurrencies.includes(option.currencyShortName);
        }
        return true;
    });

    return (
        <div className="flex flex-col gap-[20px] items-center  w-full rounded-lg">
            <AmountWithCurrency
                data={updatedUnfreezeCryptoCurrencies || []}
                amountValue={formData.cryptoAmount}
                transactionLabel="SELL"
                errorMessage={amountError ? ' ' : null}
                onAmountChange={handleAmountChange}
                onChange={e => handleAmountAndSetFormData(e)}
                selected={selectedCryptoCurrency}
                onCurrencyChange={setSelectedCryptoCurrency}
                isErrorVisible={!!amountError}
                dataE2e="sell"
            />

            <AmountWithCurrency
                data={filteredFiatData || []}
                amountValue={formData.fiatAmount}
                transactionLabel="RECEIVE"
                errorMessage={amountError}
                onAmountChange={handleAmountChange}
                onChange={e =>
                    setFormData({
                        ...formData,
                        fiatCurrency: e,
                        cryptoAmount: '',
                        fiatAmount: '',
                    })
                }
                selected={selectedFiatCurrency}
                onCurrencyChange={setSelectedFiatCurrency}
                isErrorVisible={!!amountError}
                dataE2e="receive"
            />
            {quotationError && (
                <p className="text-error text-sm font-normal font-Inter uppercase" role="alert">
                    {quotationError}
                </p>
            )}
            <div className="flex items-center justify-center w-full h-[36px] rounded-lg bg-card-bg">
                <div className="text-base font-normal flex items-center gap-2 ">
                    {exchangeLoading && (
                        <div
                            className="animate-spin h-[18px] w-[18px] border-2 border-[#A0A0AB4D] rounded-full border-t-2 !border-t-primary"
                            aria-label="Loading exchange rate"
                        />
                    )}
                    <span className="text-[14px] font-Inter font-medium !text-text">
                        1 {formData.cryptoId} = {exchangeRate || '?'} {formData.fiatCurrency}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SellCurrencyForm;
